import React, { useEffect, useMemo, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet-async";
import IconArrowRight from '../../components/svg/IconArrowRight';
import { HOME_API_URL } from '../../api/path';
import { useQuery } from 'react-query';
import Http from '../../api/Http';
import useLanguage from '../../hooks/useLanguage';
import DataLoader from '../../components/common/DataLoader';
import { Link } from 'react-router-dom';

const OurStory = ({ t }) => {
    const scroll = useRef(null);
    const [enStory, setEnStory] = useState();
    const [arStory, setArStory] = useState();
    const { language } = useLanguage();

    const srollToTop = () => {
        scroll.current.scrollIntoView({ block: 'end', behavior: 'instant' });
    }
    useEffect(() => {
        srollToTop()
    }, [])

    const queryKey = useMemo(() => ["ourStoryApi", language], [language]);
    const { data: ourStoryData, isLoading } = useQuery(
        queryKey,
        async () => {
            const response = await Http.get(HOME_API_URL.ourStoryGetApi);
            const data = response?.data;
            return data;
        }, {
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (ourStoryData) {
            // Backend returns an object with { key, value } based on language header
            // Extract the value property
            let content = null;

            if (typeof ourStoryData === 'string') {
                // If it's a string, use it directly
                content = ourStoryData;
            } else if (ourStoryData && typeof ourStoryData === 'object') {
                // If it's an object, extract the value property
                content = ourStoryData.value || ourStoryData;
            }

            // Set content based on the key or current language
            if (ourStoryData && typeof ourStoryData === 'object' && ourStoryData.key === 'ar_our_story') {
                setArStory(content);
            } else if (ourStoryData && typeof ourStoryData === 'object' && ourStoryData.key === 'our_story') {
                setEnStory(content);
            } else {
                // Fallback: set based on current language
                if (language === 'ar') {
                    setArStory(content);
                } else {
                    setEnStory(content);
                }
            }
        }
    }, [ourStoryData, language]);

    return (
        <>
            <div id={'scroll'} ref={scroll} />
            <Helmet>
                <title>Our Story - Gemellry</title>
                <meta name="description" content="Discover the story behind Gemellry. Learn about our journey, values, and commitment to excellence in jewelry and luxury products." />
            </Helmet>
            <section className='location-info-section py-5 bg-gray-light'>
                <div className="container">
                    <div className="flex items-center justify-center gap-3">
                        <Link to={'/'}> <h5 className='text-base font-nunito font-400 text-dark'>{t("front_footer.home")}</h5></Link>
                        <span><IconArrowRight className="text-dark w-4 h-4 rtl:rotate-180" /></span>
                        <h5 className='text-base font-nunito font-400 text-black'>{t("front_header.our_story")}</h5>
                    </div>
                </div>
            </section>
            {isLoading ? <DataLoader /> :
                <section className='our-story-section section-gap'>
                    <div className="container">
                        <div className="section-title mb-10 md:mb-[60px]">
                            <div data-aos="fade-right"
                                data-aos-duration="800" className="fancy-title flex items-center justify-center gap-2 sm:gap-4">
                                <h3 className='text-base-18 font-600 rtl:font-500 sm:text-lg-24 md:text-lg-28 font-cormorant uppercase fancy-heading-shape leading-1'>{t("front_header.our_story")}</h3>
                            </div>
                        </div>
                        <div className="our-story-section-content">
                            <div className="max-w-4xl mx-auto">
                                <div className="content-part mb-6 last:mb-0">
                                    {(() => {
                                        // Get content based on current language
                                        let content = language === 'ar' ? arStory : enStory;

                                        // If we have content in state, use it
                                        if (content) {
                                            return <div className="our-story-content text-base font-400 text-dark leading-relaxed [&_p]:mb-4 [&_p]:text-base [&_p]:font-400 [&_p]:text-dark [&_p]:leading-relaxed" dangerouslySetInnerHTML={{ __html: content }} />;
                                        }

                                        // Fallback: extract value from ourStoryData object if state hasn't updated yet
                                        if (ourStoryData) {
                                            if (typeof ourStoryData === 'string') {
                                                content = ourStoryData;
                                            } else if (typeof ourStoryData === 'object' && ourStoryData.value) {
                                                // Check if the key matches current language
                                                if ((language === 'ar' && ourStoryData.key === 'ar_our_story') ||
                                                    (language === 'en' && ourStoryData.key === 'our_story')) {
                                                    content = ourStoryData.value;
                                                }
                                            }

                                            if (content) {
                                                return <div className="our-story-content text-base font-400 text-dark leading-relaxed [&_p]:mb-4 [&_p]:text-base [&_p]:font-400 [&_p]:text-dark [&_p]:leading-relaxed" dangerouslySetInnerHTML={{ __html: content }} />;
                                            }
                                        }

                                        return <div className="text-center text-gray-dark">Loading content...</div>;
                                    })()}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </>
    )
}

export default withTranslation()(OurStory)

